export const dedupeBy = <T, K extends keyof T>(arr: T[], byKey: K): T[] =>
  Object.values(Object.fromEntries(arr.map((element) => [element[byKey], element])));
